// @ts-nocheck
import * as React from "react";

const Options2Fill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M11.5 20.5v-5h1v2h8v1h-8v2h-1Zm-8-2v-1h5v1h-5Zm4-4v-2h-4v-1h4v-2h1v5h-1Zm4-2v-1h9v1h-9Zm4-4v-5h1v2h4v1h-4v2h-1Zm-12-2v-1h9v1h-9Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Options2Fill);
